import script from "./CampaignBig.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignBig.vue?vue&type=script&setup=true&lang=js"

import "./CampaignBig.vue?vue&type=style&index=0&id=3368d4c5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3368d4c5"]])

export default __exports__